import { Fragment, useState } from 'react';

// components - material UI
import { Button } from '@material-ui/core';

// Modal
import Modal from '../modal/Modal';
import ModalContainer from '../modal/ModalContainer';

// Icons
import LinkIcon from '@material-ui/icons/Link';

const Tag = ({
    text, 
    modal_header, 
    icon, 
    classes, 
    redirect_url,
    price_tag
}) =>  {

    const [redirectModal, setRedirectModal] = useState(false);

    const toggleRedirectModal = () => {
        
        setRedirectModal(!redirectModal);
    }

    const handleRedirect = () => {
        setRedirectModal(false);
        window.open(redirect_url, "_blank");
    }


	return (
        <Fragment>

            <div onClick={redirect_url ? toggleRedirectModal : null} className={`post_tag icon_14 no_padding ${classes || ''} ${price_tag ? 'price_tag' : ''}`}>

                {/* Icon */}
                {icon && (
                    <Fragment>
                        {icon}
                        <span style={{width: '5px'}}></span>
                    </Fragment>
                )}

                {price_tag ? text.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }) : text}
            </div>

            {/* Redirect Modal */}
            <ModalContainer show={redirectModal} onClose={toggleRedirectModal}>
                <Modal>

                    {/* Modal Title */}
                    <div>
                        <h2 style={{color: 'black'}}>{modal_header}</h2>
                    </div>

                    {/* Modal Description */}
                    <p>You are about to be redirected. Do you want to continue?</p>

                    {/* Modal Actions */}
                    <Button 
                        onClick={handleRedirect}
                        variant="outlined" 
                        className="sidebar__tweet black"
                        fullWidth
                    >
                        <LinkIcon />
                        <span style={{width: '5px'}}></span>
                        Yes
                    </Button>
                    <Button 
                        onClick={toggleRedirectModal}
                        variant="outlined" 
                        className="sidebar__tweet ghost"
                        fullWidth
                    >
                        No
                    </Button>
                </Modal>
            </ModalContainer>
        </Fragment>
	);
}
  
export default Tag;
  